import React, { useState, useContext, useEffect } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import { Context } from "routes/private/Editor/Context";
import MultiEditingIcon from '@assets/icons/multiEditingIcon';
import ToolTip from '@components/Tooltip';

const MultiEditingTool:React.FC<IProps> = (props) => {
  let context = useContext(Context);
  
  const handleOpenMultiEditing = () => {  
    const picker = (context.editorStatus.currentPicker==="MultiEditing")?undefined:"MultiEditing";
    context.onShowPicker(picker);
  }
  
  return (
    <S.Root>
      <S.IconContainer
        onClick={handleOpenMultiEditing}
      >
        <ToolTip
          tip="Multieditor"
          boxStyle={{
            top: `0px`,
            left: `30px`,
            right: `auto`,
            width: `140px`,
            justifyContent: `start`
          }}
        >
          <MultiEditingIcon
            style={{fillColor: (context.editorStatus.currentPicker==="MultiEditing") ? C.WHITE : undefined}}
          />
        </ToolTip>
      </S.IconContainer>
    </S.Root>
  );
}

export default MultiEditingTool;